import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { cleanObject } from "utils/cleanObject";
import { ApiArrayResponseType } from "types/api.types";

export interface ProductsQueryParams {
  id?: string;
  search?: string;
}

export const useGetProductsQuery = ({ id, search }: ProductsQueryParams) => {
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  const queryParams = new URLSearchParams();

  if (id) queryParams.append("search", id);

  const url = id ? `/products/${id}` : `/products?${queryParams.toString()}`;

  return useQuery({
    queryKey: ["useGetProductsQuery", { id }, search],
    queryFn: () =>
      axiosInstance
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { search },
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};

export type ProductsParams = {
  search?: string;
  page?: number;
};

export interface ProductItem {
  name: string;
  images: string[];
  categories: Category[];
  unitPrice: number;
  bulkPrice: number;
  bulkTotalStock: number;
  createdAt: string;
  productId: number;
  id: string;
}

export interface Category {
  name: string;
  id: string;
}

export const useProducts = (params: ProductsParams = {}) => {
  const url = `/products`;

  return useQuery({
    queryKey: ["useGetProductsQuery", params.search],
    queryFn: () =>
      axiosInstance
        .get<ApiArrayResponseType<ProductItem>>(url, {
          params: cleanObject(params),
        })
        .then((res) => res.data),
  });
};
